import { Labs } from 'prove-common'
import { ReferenceTable } from '../reference-table/ReferenceTable'

type LabsTableProps = {
  labs: Labs
}

export const LabsTable = ({ labs }: LabsTableProps) => {
  return (
    <ReferenceTable
      rows={labs}
      title='Laboratorier'
      emptyTitle='Ingen laboratorier'
      columns={[
        { key: 'name', label: 'Navn', value: (lab) => lab.name },
        { key: 'info', label: 'Informasjon', value: (lab) => lab.info },
        { key: 'id', label: 'ID', value: (lab) => lab.id, copy: true }
      ]}
      name={(lab) => lab.name}
      detailPath={(lab) => `/labs/${lab.id}`}
    />
  )
}
